// Date helpers for the dashboard. We treat the "day" as midnight-to-midnight
// in the browser's local timezone, which for the camp ranger and Matt is
// Eastern. Anyone in another timezone sees their local day, which shifts the
// bucket boundaries on the chart but doesn't break correctness.

export function todayString(): string {
  return toDateString(new Date());
}

export function toDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function fromDateString(yyyymmdd: string): Date {
  // Local-midnight of the given date.
  return new Date(`${yyyymmdd}T00:00:00`);
}

export function addDays(yyyymmdd: string, n: number): string {
  const d = fromDateString(yyyymmdd);
  d.setDate(d.getDate() + n);
  return toDateString(d);
}

export interface IsoBounds {
  fromIso: string;
  toIso: string;
}

export function localDayBounds(yyyymmdd: string): IsoBounds {
  const start = fromDateString(yyyymmdd);
  const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
  return { fromIso: start.toISOString(), toIso: end.toISOString() };
}

export function rangeBounds(daysBack: number, todayDate: Date = new Date()): IsoBounds {
  const today = toDateString(todayDate);
  const start = fromDateString(addDays(today, -daysBack + 1));
  const end = new Date(fromDateString(today).getTime() + 24 * 60 * 60 * 1000);
  return { fromIso: start.toISOString(), toIso: end.toISOString() };
}

export function formatLongDate(yyyymmdd: string): string {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(fromDateString(yyyymmdd));
}
